import { gql } from "apollo-boost"

export const getAccountByUid = gql`
query getAccountByUid($uid: String!) {
  AccountByUid(uid: $uid) {
    id
    roles {
      role
      regions
    }
  }
}
`